// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16dW9","content":"styles_content__1xDd_","row":"styles_row__3ViL_","footer":"styles_footer__3XGNv","phraseLength":"styles_phraseLength__gmVkk"};